module.exports = __webpack_public_path__ + "img/teacher_3.5a42c8d2.png";